import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';

import { MatNavList, MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import {
  AmplitudeSource,
  UIEventEnum,
} from 'src/app/utility/amplitude-tracking/tracking.types';
import { TrackingService } from 'src/app/utility/amplitude-tracking/tracking.service';

export interface CustomSideTab {
  name: string;
  value: number;
  number?: number;
  icon?: string;
  paramName?: string;
  alternativeParamNames?: string[];
  externalLink?: string;
  tooltip?: string;
}

@Component({
  selector: 'qa-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  imports: [
    NgScrollbar,
    MatNavList,
    MatListItem,
    MatIcon,
    TranslateModule,
    MatTooltip,
  ],
})
export class SideMenuComponent implements OnInit {
  @Input() tabList: CustomSideTab[] = [];
  @Input() sideMenuTitle: string;
  @Output() selectedTab = new EventEmitter();
  active = '';

  constructor(route: ActivatedRoute, private trackingService: TrackingService) {
    route.queryParams.subscribe((params) => {
      if (params?.tab) {
        this.active = params?.tab;
      }
    });
  }

  ngOnInit(): void {
    if (!this.active) {
      this.active = this.tabList[0].paramName;
    }
  }

  onMenuClick(i: number, tab: CustomSideTab) {
    if (tab.externalLink) {
      window.open(tab.externalLink, '_blank');
      return;
    }
    if (tab.paramName === 'subscription') {
      this.trackingService.trackEvent({
        event_type: UIEventEnum.SUBSCRIPTION_OPENED,
        event_properties: {
          source: AmplitudeSource.PROFILE,
        },
      });
    }
    this.active = tab.paramName;
    let obj = {
      index: i,
      tab: tab.paramName,
    };
    this.selectedTab.emit(obj);
  }

  isTabActive(param: CustomSideTab): boolean {
    return (
      this.active === param.paramName ||
      (param.alternativeParamNames &&
        param.alternativeParamNames.includes(this.active))
    );
  }
}
